module.exports = __webpack_public_path__ + "img/V27.84babb86.png";